import React from 'react';

export const IconListView: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="popup-icon popup-icon--list-view"
  >
    <rect x="3" y="3" width="14" height="6" rx="1" stroke="var(--color-type-primary)" />
    <rect x="3" y="11" width="14" height="6" rx="1" stroke="var(--color-type-primary)" />
  </svg>
);
